import { render, staticRenderFns } from "./listadoSolicitudes.vue?vue&type=template&id=283ab4c2"
import script from "./listadoSolicitudes.vue?vue&type=script&lang=js"
export * from "./listadoSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports